import { createContext, useContext, useEffect, useLayoutEffect, useRef } from 'react';

import { useNavigationPinState } from './useNavigationPinState';
import styles from './VerticalNavigation.module.css';

const EXPAND_STORAGE_KEY = 'azma-navigation-expanded';

const NavigationContext = createContext(null);

export const toggleForceToExpandNavigation = () => {
    if (document.documentElement.dataset.navExpanded === '1') {
        document.documentElement.dataset.navExpanded = '0';
        try {
            localStorage.setItem(EXPAND_STORAGE_KEY, '0');
        } catch {
            // storage unavailable
        }
    } else {
        document.documentElement.dataset.navExpanded = '1';
        try {
            localStorage.setItem(EXPAND_STORAGE_KEY, '1');
        } catch {
            // storage unavailable
        }
    }
};

export const NavigationProvider = ({ children, className }) => {
  const navRef = useRef(null);
  const [isExpanded, setIsExpanded] = useNavigationPinState();

  useLayoutEffect(() => {
    if (isExpanded) {
      document.documentElement.dataset.navExpanded = '1';
    }
  }, []);

  useEffect(() => {
    const savedRef = navRef.current;
    if (savedRef) {
      const resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          if (entry.contentBoxSize) {
            const contentBoxSize = entry.contentBoxSize[0];
            setIsExpanded(contentBoxSize.inlineSize > 230);
          }
        }
      });
      resizeObserver.observe(savedRef);
      return () => resizeObserver.unobserve(savedRef);
    }
    return undefined;
  }, [navRef]);

  return (
    <NavigationContext.Provider value={isExpanded}>
      <nav
        id="vertical"
        className={className ? `${styles.nav} ${className}` : styles.nav}
        ref={navRef}
        aria-label="ناوبری اصلی"
      >
        {children}
      </nav>
    </NavigationContext.Provider>
  );
};

export function useNavigationContext() {
    const context = useContext(NavigationContext);
    if (context === null) {
        throw new Error(
            'useNavigationContext needs to be used within a NavigationContext.Provider',
        );
    }
    return context;
}